// test159
(159 && 0);
